import { useLocation, Outlet, Navigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'

import { setAuthorized } from '../../redux/authService/authSlice'

const RequireAuth = () => {
	const location = useLocation()
	const authorized = localStorage.getItem('authorized')
	const auth = useSelector(state => state.auth.authorized)
	const dispatch = useDispatch()

	const [available, setAvailable] = useState(authorized === 'true' ? true : false)

	useEffect(() => {
		if (authorized === 'true' || auth) {
			setAvailable(true)
			dispatch(setAuthorized(true))
		} else {
			setAvailable(false)
			dispatch(setAuthorized(false))
		}
	}, [auth, authorized, dispatch])

	return (
		<>
			{available ?
				<Outlet />
				: <Navigate to="/" state={{ from: location }} replace />}
		</>
	)
}

export default RequireAuth